<template>
  <Row
    :class="`annual-profit-row${computedClass}`"
    :has-interaction="!profitData.isDisabled"
    :has-line="hasDivider"
    data-testid="annual-profit-row"
    @click="goToProfitDetail"
  >
    <template #top-left>
      <BaseText size="md" :color="getTextColor">{{
        profitData.month
      }}</BaseText>
    </template>
    <template #top-right>
      <BaseText size="md" :color="getTextColor">
        <Money>{{ profitData.profitReceived.formatted }}</Money>
      </BaseText>
    </template>
    <template #icon-right>
      <ButtonIconContextual
        :disabled="profitData.isDisabled"
        label="Ver detalhes"
        size="small"
        icon="EA0170"
      />
    </template>
  </Row>
</template>

<script setup lang="ts">
import {
  BaseText,
  Row,
  ButtonIconContextual
} from '@warrenbrasil/nebraska-web';
import { ProfitMonthlies } from '@/modules/wealth/services/portfolio';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { useRouter } from 'vue-router/composables';
import { Money } from '@/modules/common/components/Money';
import { WarrenSession } from '@/modules/common/services/session';
import { StorageKeys } from '@/modules/common/services/local-storage';

interface Props {
  portfolioId: string;
  year: string;
  profitData: ProfitMonthlies;
  hasDivider: boolean;
}
const props = defineProps<Props>();
const router = useRouter();
const computedClass = props.profitData.isDisabled ? ' disabled' : '';
const getTextColor = props.profitData.isDisabled
  ? NebraskaColors.textDisabled
  : '';

const goToProfitDetail = () => {
  if (props.profitData.isDisabled) return;

  WarrenSession.set(
    StorageKeys.ProfitMonthlyAmount,
    props.profitData.profitReceived.formatted,
    true
  );

  router.replace({
    name: 'wealthIndexPortfolioProfitDetail',
    params: {
      portfolioId: props.portfolioId,
      year: props.year,
      month: String(props.profitData.monthIndex)
    }
  });
};
</script>

<style lang="less" scoped>
.disabled {
  color: @element-disabled;

  :deep(.icon) {
    color: @element-disabled !important;
  }
}

.annual-profit-row {
  :deep(.wrapper) {
    .container-right {
      align-self: center;
    }

    .container-left {
      align-self: center;
    }
  }

  &__container-right {
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
    height: 100%;
    margin-left: @size-spacing-x300;
  }

  &:deep(.container-right > div) {
    height: 100%;
  }

  &__watchlist-button {
    align-self: center;
    margin-left: @size-spacing-x150;
  }
}
</style>
